import { render, staticRenderFns } from "./AssignStoreBadgeToHoliday.vue?vue&type=template&id=59d8e865&scoped=true&"
import script from "./AssignStoreBadgeToHoliday.vue?vue&type=script&lang=js&"
export * from "./AssignStoreBadgeToHoliday.vue?vue&type=script&lang=js&"
import style0 from "./AssignStoreBadgeToHoliday.vue?vue&type=style&index=0&id=59d8e865&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8e865",
  null
  
)

export default component.exports